import React from "react";
import styled from "styled-components";
import Icon from '@material-ui/core/Icon'
import Popover from "@material-ui/core/Popover";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";

const CustomPopover = withStyles({
  paper: {
    background: "#060c29",
    borderRadius: "12px",
  },
})(Popover);


const Item = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 4px 8px;
  cursor: pointer;
  margin-bottom: 3px;
  &:hover {
    border-radius: 8px;
    background: #414554;
    transition: 0.2s ease background;
  }

  p {
    color: #fff;
    font-size: .8rem;
    font-weight: bold;
    white-space: nowrap;
    width: 160px;
    padding-right: 8px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 28px;
    height: 28px;
  }

`;

const Content = styled.div`
  color: #898989;
  padding: 8px;
  min-height: 110px;
  max-height: 260px;
`;

const ListItem = ({ name, onClick }) => {
  return (
    <Item onClick={onClick}>
      <p>{name}</p>
      <Icon>search</Icon>
    </Item>
  );
};

const CalendarMenu = ({anchorEl, onClose, menuData, history}) => {
  const open = Boolean(anchorEl);

  return (
    <>
      <CustomPopover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Content>
          {menuData && menuData.map((entry) => {
            return (
              <ListItem
                key={entry.id}
                name={entry.name}
                onClick={() => {
                  history.push(
                    "/dashboard/inspect/" + entry.id + "/overview"
                  );
                }}
              />
            )
          })}
        </Content>
      </CustomPopover>
    </>
  );
};

export default withRouter(CalendarMenu);